import React, { useState } from 'react';
import { Button, Modal, Spinner } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { CustomerContactPerson } from 'models/contact-person';
import CustomerContactService from 'services/customer-contact.service';
import { InitContextProps, useAuthContext } from 'services/context/authentication.context';

interface DeleteCustomerContactModalProps {
    contact: CustomerContactPerson;
    handleModalHide: () => void;
    onDeleteSuccess: () => void;
}

export function DeleteCustomerContactModal(props: DeleteCustomerContactModalProps) {
    const { state }: InitContextProps = useAuthContext();
    const [loading, setLoading] = useState(false);

    const onConfirm = async () => {
        const contactPersonId = state.customer?.contactId;
        if (!contactPersonId) return;

        setLoading(true);

        try {
            await CustomerContactService.deleteContactPerson(props.contact.id, contactPersonId);

            toast.success('Kasutaja edukalt kustutatud.');

            props.onDeleteSuccess();
            props.handleModalHide();
        } catch (e) {
            toast.error('Tekkis viga kasutaja kustutamisel.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            show={true}
            size={"lg"}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            onHide={props.handleModalHide}
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Kasutaja kustutamine
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div>
                    Kas olete kindel, et soovite kustutada kasutaja <strong>{props.contact.contactName}</strong>?
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
                <Button variant="outline-dark"
                        onClick={props.handleModalHide}
                        disabled={loading}
                        type="button"
                        className={"d-flex align-items-center"}>
                    <span className='px-2'>Tühista</span>
                </Button>
                <Button
                    variant="danger"
                    onClick={onConfirm}
                    disabled={loading}
                    type="button"
                    className="d-flex align-items-center"
                >
                    <span className='px-2'>{ loading && <Spinner animation='border' size='sm' className='mr-2' /> } Kustuta</span>
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
